// extracted by mini-css-extract-plugin
module.exports = {"sliceContainer":"SliceContainer_sliceContainer__Vbe_3","defaultPadding":"SliceContainer_defaultPadding__jWurn"};